import { post } from 'Api';

export const COMPETITION_ENTRY_INITIAL = 'frontend/competition-entry/COMPETITION_ENTRY_INITIAL';
export const COMPETITION_ENTRY_TRUE = 'frontend/competition-entry/COMPETITION_ENTRY_TRUE';
export const COMPETITION_ENTRY_FALSE = 'frontend/competition-entry/COMPETITION_ENTRY_FALSE';
export const COMPETITION_ENTRY_ERROR = 'frontend/competition-entry/COMPETITION_ENTRY_ERROR';

export const initialState = [];

export function hasUserEnteredCompetition(competitionId, email) {
  return async (dispatch) => {
    const { response, data } = await post(dispatch, '/competition/check-entry', { competitionId, email });
    if (response.ok) {
      const { entered } = data;
      if (entered) {
        return dispatch({ type: COMPETITION_ENTRY_TRUE, payload: { competitionId, email } });
      }
      return dispatch({ type: COMPETITION_ENTRY_FALSE, payload: { competitionId, email } });
    }
    return dispatch({ type: COMPETITION_ENTRY_ERROR, payload: { competitionId, email } });
  };
}
